import script from "./AbitImageUpload.vue?vue&type=script&lang=ts&setup=true"
export * from "./AbitImageUpload.vue?vue&type=script&lang=ts&setup=true"

import "./AbitImageUpload.vue?vue&type=style&index=0&id=1776de53&lang=css"

const __exports__ = script;

export default __exports__